var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrendingUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6461 7.05312L18.0861 8.49312L13.2061 13.3731L9.91612 10.0831C9.52612 9.69313 8.89612 9.69313 8.50612 10.0831L2.50612 16.0931C2.11612 16.4831 2.11612 17.1131 2.50612 17.5031C2.89612 17.8931 3.52612 17.8931 3.91612 17.5031L9.20612 12.2031L12.4961 15.4931C12.8861 15.8831 13.5161 15.8831 13.9061 15.4931L19.4961 9.91313L20.9361 11.3531C21.2461 11.6631 21.7861 11.4431 21.7861 11.0031V6.70312C21.7961 6.42312 21.5761 6.20312 21.2961 6.20312H17.0061C16.5561 6.20312 16.3361 6.74312 16.6461 7.05312Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendingUp);
export default __webpack_public_path__ + "static/media/TrendingUp.de5f1af37e7f5ac3dd404b4c92d006a7.svg";
export { ForwardRef as ReactComponent };